import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { FormlyErrorComponent } from '../formly-error.component';
import { MatIcon } from '@angular/material/icon';
import { FieldLabelRowComponent } from './field-label-row.component';
import { FormlyDataCyDirective } from '../../directives/formly-data-cy.directive';

@Component({
  selector: 'formly-field-time',
  template: `
    <mat-form-field class="dd-compact-field w-full" [class.mat-form-field-invalid]="formControl.invalid && formControl.touched">
      @if (field.props.label) {
      <mat-label>
        <app-field-label-row [label]="field.props.label" [required]="field.props.required" [info]="props.info"></app-field-label-row>
      </mat-label>
      }
      @if (props.addonLeft) {
      <span class="text-md text-gray-500 px-2 inline-block" matPrefix>
        @if (props.addonLeft.icon) {
        <mat-icon>{{ props.addonLeft.icon }}</mat-icon>
        }
        @if (props.addonLeft.text) {
        <span>{{ props.addonLeft.text }}</span>
        }
      </span>
      }
      <input
        matInput
        type="time"
        step="900"
        [class.dd-time-empty]="!formControl.value"
        [attr.aria-label]="props.ariaLabel || null"
        [required]="field.props.required"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [formlyDataCy]="field" />
      @if (props.addonRight) {
      <span class="text-md text-gray-500 px-2 inline-block" matSuffix>
        @if (props.addonRight.icon) {
        <mat-icon>{{ props.addonRight.icon }}</mat-icon>
        }
        @if (props.addonRight.text) {
        <span>{{ props.addonRight.text }}</span>
        }
      </span>
      }
      @if (field.props.description) {
      <mat-hint>{{ field.props.description }}</mat-hint>
      }
    </mat-form-field>
    <app-formly-error [field]="field"></app-formly-error>
  `,
  imports: [
    ReactiveFormsModule,
    FormlyModule,
    MatInputModule,
    FormlyErrorComponent,
    MatIcon,
    FormlyDataCyDirective,
    FieldLabelRowComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyTimeType extends FieldType implements OnInit {
  ngOnInit() {
    if (this.field.formControl.value == null && this.field.defaultValue != null) {
      this.formControl.patchValue(this.field.defaultValue);
    }
  }
}
